/* Dear eM — tiện ích cửa hàng (Claude v22.3)
   1) PDP: option con chỉ hiện giá trị thuộc option cha đang chọn (vd. chọn "Small" chỉ hiện màu có ở Small)
   2) Upsell gói quà (hộp / túi giấy / thiệp) có nút thêm nhanh: trong PDP, giỏ hàng nổi (thu gọn) và trang giỏ hàng
   3) Thiệp: khách tự nhập lời chúc (tối đa 150 ký tự, 7 dòng, 30 ký tự/dòng, tự xuống dòng) — trên trang thiệp và khi thêm nhanh
   4) Lưu ý nhập địa chỉ cũ (trước sáp nhập tỉnh) trước khi thanh toán */
(function () {
  if (window.__dmStore) return; window.__dmStore = 1;
  var cfg = window.DM_STORE || {};
  var GIFT = cfg.giftHandles || ['hop-qua-signature-dear-em', 'tui-giay-qua-tang-signature-dear-em', 'thiep-viet-loi-chuc-dear-em'];
  var CARD = cfg.cardHandle || 'thiep-viet-loi-chuc-dear-em';
  var MSG = { max: 150, lines: 7, per: 30, prop: 'Lời chúc' };
  /* 1 hộp / 1 túi / 1 thiệp = dùng cho 1 sản phẩm chính */
  var QTY_NOTE = 'Mỗi hộp, túi hoặc thiệp dùng cho <b>1 sản phẩm chính</b>. Mua nhiều món, bạn thêm số lượng tương ứng nhé.';
  var qtyNote = function (m) { return '<p class="dmu-qn"' + (m ? ' style="margin:' + m + '"' : '') + '>ⓘ ' + QTY_NOTE + '</p>'; };
  /* Hộp quà / túi giấy: khách không chọn form – giỏ có Vanity Case thì dùng form vuông, còn lại form chữ nhật */
  var FORM = cfg.formHandles || { 'hop-qua-signature-dear-em': { sq: 'BOX-SQ-SIG', rec: 'BOX-REC-SIG' }, 'tui-giay-qua-tang-signature-dear-em': { sq: 'BAG-SQ-SIG', rec: 'BAG-REC-SIG' } };
  var isVanity = function (i) { return /vanity/i.test((i.handle || '') + ' ' + (i.product_type || '')); };
  var formOf = function (cart) { return (cart && cart.items || []).some(isVanity) ? 'sq' : 'rec'; };
  var lastCart = null;
  function getCart() { return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { lastCart = c; return c; }).catch(function () { return lastCart || { items: [] }; }); }
  function formVariant(p, form) {
    var f = FORM[p.handle]; if (!f) return null;
    return p.variants.filter(function (v) { return v.sku === f[form]; })[0] || p.variants.filter(function (v) { return form === 'sq' ? /vuông/i.test(v.title) : /chữ nhật/i.test(v.title); })[0] || p.variants[0];
  }
  var money = function (c) { return (c / 100).toLocaleString('vi-VN') + 'đ'; };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  (function css() {
    var s = document.createElement('style'); s.id = 'dm-store-css';
    s.textContent = '.dmu{border:1px solid #e6dcf7;background:#faf7ff;border-radius:14px;padding:1.2rem 1.4rem;margin:1.2rem 0;font-size:1.35rem;text-align:left}' +
      '.dmu-h{margin:0 0 .8rem;font-weight:700;font-size:1.45rem;color:#1f1b24}' +
      '.dmu-list .dmu-item{display:flex;align-items:center;gap:1rem;padding:.7rem 0;border-top:1px dashed #e6dcf7}.dmu-list .dmu-item:first-child{border-top:0}' +
      '.dmu-item img,.dmu-ph{width:48px;height:48px;border-radius:10px;object-fit:cover;flex:0 0 48px;background:#efe8fb}' +
      '.dmu-info{flex:1;min-width:0;display:flex;flex-direction:column;gap:.3rem}' +
      '.dmu-name{color:#1f1b24;font-weight:600;text-decoration:none;line-height:1.3}.dmu-price{color:#7f63bd;font-weight:600}' +
      '.dmu-sel{font:inherit;font-size:1.2rem;padding:.3rem .5rem;border:1px solid #d9cdf0;border-radius:8px;background:#fff;max-width:100%;width:100%}' +
      '.dmu-add{flex:0 0 auto;border:0;border-radius:999px;background:#9b7fd4;color:#fff;font-weight:700;font-size:1.3rem;padding:.7rem 1.3rem;cursor:pointer;white-space:nowrap;font-family:inherit}.dmu-add:disabled{opacity:.7;cursor:default}' +
      /* dạng hàng ngang gọn: giỏ hàng nổi + trang giỏ hàng */
      '.dmu-row{display:grid;grid-auto-flow:column;grid-auto-columns:minmax(11.5rem,1fr);gap:.8rem;overflow-x:auto;scrollbar-width:none;padding:.2rem 0 .2rem}.dmu-row::-webkit-scrollbar{display:none}' +
      '.dmu-row .dmu-item{display:flex;flex-direction:column;align-items:stretch;gap:.5rem;background:#fff;border:1px solid #ece6f6;border-radius:12px;padding:.8rem;min-width:0}' +
      '.dmu-row .dmu-top{display:flex;gap:.7rem;align-items:center}.dmu-row .dmu-item img,.dmu-row .dmu-ph{width:40px;height:40px;flex-basis:40px;border-radius:8px}' +
      '.dmu-row .dmu-name{font-size:1.2rem;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
      '.dmu-row .dmu-price{font-size:1.2rem}.dmu-row .dmu-add{padding:.5rem .8rem;font-size:1.2rem;width:100%}' +
      'details.dmu{padding:0;overflow:hidden}details.dmu>summary{list-style:none;cursor:pointer;display:flex;align-items:center;gap:.8rem;padding:.9rem 1.2rem}details.dmu>summary::-webkit-details-marker{display:none}' +
      '.dmu-sum b{font-size:1.35rem;color:#1f1b24}.dmu-sum span{flex:1;font-size:1.2rem;color:#7f63bd;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.dmu-sum i{font-style:normal;transition:transform .2s;color:#7f63bd}' +
      'details.dmu[open]>summary i{transform:rotate(180deg)}details.dmu>.dmu-body{padding:0 1rem 1rem}' +
      '.dmu--page{margin-top:2rem}.dmu--page .dmu{max-width:64rem;margin-left:auto}' +
      /* lời chúc trên thiệp */
      '.dmc-msg{margin:.8rem 0 0;background:#fff;border:1px solid #e6dcf7;border-radius:12px;padding:1rem}' +
      '.dmc-msg label{display:block;font-weight:700;font-size:1.3rem;margin-bottom:.5rem;color:#1f1b24}' +
      '.dmc-msg textarea{width:100%;box-sizing:border-box;min-height:9.6rem;font:inherit;font-size:1.45rem;line-height:1.5;padding:.8rem 1rem;border:1px solid #d9cdf0;border-radius:10px;resize:vertical;background:#fff;color:#1f1b24}' +
      '.dmc-msg textarea:focus{outline:0;border-color:#9b7fd4;box-shadow:0 0 0 3px rgba(155,127,212,.18)}' +
      '.dmc-meta{display:flex;justify-content:space-between;gap:1rem;font-size:1.15rem;color:#7a7385;margin:.4rem 0 .6rem}.dmc-meta .bad{color:#c0392b}' +
      '.dmc-msgcard{background:linear-gradient(135deg,#fffdf8,#f7f1ff);border:1px dashed #c9bbe8;border-radius:10px;padding:1.2rem 1rem;text-align:center;font-family:"Be Vietnam Pro",inherit;font-size:1.35rem;line-height:1.55;color:#4a3f5c;min-height:4rem;white-space:pre;overflow:hidden}' +
      '.dmc-msgcard:empty:before{content:"Lời chúc sẽ hiện ở đây";color:#b3a8c6}' +
      '.dmc-actions{display:flex;gap:.8rem;margin-top:.8rem}.dmc-actions .dmu-add{flex:1}.dmc-cancel{border:1px solid #e6dcf7;background:#fff;border-radius:999px;padding:.6rem 1.2rem;font:inherit;font-size:1.25rem;cursor:pointer}' +
      '.dm-addr-note{background:#fff7e6;border:1px solid #f3d38b;color:#5a4410;border-radius:12px;padding:1rem 1.2rem;margin:1rem 0;font-size:1.3rem;line-height:1.5;text-align:left}' +
      'cart-drawer .dm-addr-note{font-size:1.2rem;padding:.8rem 1rem;margin:.6rem 0}cart-drawer details.dmu{margin:0 0 .8rem}' +
      '.dmc-pdp{margin:1.6rem 0}' +
      '.dmu-qn{margin:0 0 .8rem;font-size:1.2rem;line-height:1.45;color:#5d5866}.dmu-qn b{color:#5b3fa0}details.dmu .dmu-qn{margin:0 0 .7rem}' +
      /* v22.1: không chọn variant trong cửa sổ thiết kế – chọn Dòng/Màu ở ngoài PDP (dạng pill) */
      '.dmc-vopts{display:none!important}';
    document.head.appendChild(s);
  })();

  /* ---------- 0) Fix v22: Dawn đọc option[selected] (thuộc tính) khi đổi variant. Khi script khác (customizer, option phụ thuộc)
     đổi nhiều select cùng lúc nhưng chỉ bắn 1 sự kiện change, select còn lại giữ thuộc tính cũ → Dawn trả về sai variant.
     Đồng bộ thuộc tính selected của mọi select trước khi Dawn xử lý (capture phase). ---------- */
  document.addEventListener('change', function (e) {
    var r = e.target && e.target.closest && e.target.closest('variant-selects'); if (!r) return;
    $$('select', r).forEach(function (s) {
      $$('option', s).forEach(function (o) {
        var on = o.value === s.value;
        if (on !== o.hasAttribute('selected')) { if (on) o.setAttribute('selected', 'selected'); else o.removeAttribute('selected'); }
      });
    });
  }, true);

  /* ---------- 1) Option phụ thuộc ---------- */
  var product = null;
  function loadProduct() {
    if (product || !/\/products\//.test(location.pathname)) return Promise.resolve(product);
    var url = location.pathname.replace(/\/$/, '').split('?')[0] + '.js';
    return fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) { product = p; return p; }).catch(function () { return null; });
  }
  function validValues(idx, chosen) {
    var set = {};
    (product.variants || []).forEach(function (v) {
      for (var k = 0; k < idx; k++) { if (chosen[k] != null && v.options[k] !== chosen[k]) return; }
      set[v.options[idx]] = set[v.options[idx]] || v.available;
    });
    return set; // value -> available?
  }
  var busy = false;
  function applyDeps() {
    if (!product || !product.options || product.options.length < 2 || busy) return;
    busy = true;
    try {
      $$('variant-selects').forEach(function (root) {
        var names = product.options.map(function (o) { return o.name || o; });
        var chosen = names.map(function (n, i) {
          var sel = root.querySelector('select[name="options[' + n + ']"]');
          if (sel) return sel.value;
          var r = root.querySelector('input[type=radio][name^="' + n + '"]:checked');
          return r ? r.value : null;
        });
        for (var i = 1; i < names.length; i++) {
          var ok = validValues(i, chosen), n = names[i];
          var sel = root.querySelector('select[name="options[' + n + ']"]');
          if (sel) {
            $$('option', sel).forEach(function (o) { var bad = !(o.value in ok); if (o.hidden !== bad) o.hidden = bad; if (o.disabled !== bad) o.disabled = bad; });
            if (!(sel.value in ok)) {
              var first = Object.keys(ok).filter(function (k) { return ok[k]; })[0] || Object.keys(ok)[0];
              if (first != null) { sel.value = first; chosen[i] = first; sel.dispatchEvent(new Event('change', { bubbles: true })); }
            }
          } else {
            $$('input[type=radio][name^="' + n + '"]', root).forEach(function (x) {
              var bad = !(x.value in ok), l = root.querySelector('label[for="' + x.id + '"]');
              if (x.hidden !== bad) x.hidden = bad; if (l && (l.style.display === 'none') !== bad) l.style.display = bad ? 'none' : '';
            });
            /* đang chọn giá trị không còn hợp lệ (vd. Premium + Hồng nhạt) → tự chọn giá trị hợp lệ đầu tiên */
            var radios = $$('input[type=radio][name^="' + n + '"]', root), cur = radios.filter(function (x) { return x.checked; })[0];
            if (cur && !(cur.value in ok)) {
              var nx = radios.filter(function (x) { return ok[x.value]; })[0] || radios.filter(function (x) { return x.value in ok; })[0];
              if (nx) { nx.checked = true; chosen[i] = nx.value; nx.dispatchEvent(new Event('change', { bubbles: true })); }
            }
          }
        }
        // chip trong popup thiết kế (customizer)
        $$('.dmc-vchip').forEach(function (b) {
          var i = names.indexOf(b.dataset.opt); if (i < 1) return;
          var ok = validValues(i, chosen), want = (b.dataset.val in ok) ? '' : 'none'; if (b.style.display !== want) b.style.display = want;
        });
      });
    } finally { busy = false; }
  }
  function initDeps() {
    loadProduct().then(function (p) {
      if (!p || !p.options || p.options.length < 2) return;
      applyDeps();
      document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects')) setTimeout(applyDeps, 0); }, true);
      new MutationObserver(function () { applyDeps(); }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden'] });
    });
  }

  /* ---------- 3) Lời chúc trên thiệp ---------- */
  function wrapMsg(raw) {
    var out = [];
    String(raw || '').replace(/\r/g, '').split('\n').forEach(function (p) {
      p = p.replace(/[ \t]+/g, ' ').trim();
      if (!p) { out.push(''); return; }
      var line = '';
      p.split(' ').forEach(function (w) {
        while (w.length > MSG.per) { if (line) { out.push(line); line = ''; } out.push(w.slice(0, MSG.per)); w = w.slice(MSG.per); }
        if (!w) return;
        if (!line) line = w; else if ((line + ' ' + w).length <= MSG.per) line += ' ' + w; else { out.push(line); line = w; }
      });
      if (line) out.push(line);
    });
    while (out.length && out[out.length - 1] === '') out.pop();
    while (out.length && out[0] === '') out.shift();
    return out;
  }
  function msgHTML(withButtons) {
    return '<div class="dmc-msg">' +
      '<label>Lời chúc trên thiệp <span style="font-weight:400;color:#7a7385">(Dear eM viết tay giúp bạn)</span></label>' +
      '<textarea maxlength="' + MSG.max + '" rows="4" placeholder="Ví dụ: Chúc mừng sinh nhật Linh! Mong em luôn xinh đẹp và hạnh phúc ♥" data-dmc-input></textarea>' +
      '<div class="dmc-meta"><span data-dmc-lines>0/' + MSG.lines + ' dòng · tối đa ' + MSG.per + ' ký tự/dòng</span><span data-dmc-count>0/' + MSG.max + '</span></div>' +
      '<div class="dmc-msgcard" data-dmc-preview aria-live="polite"></div>' +
      (withButtons ? '<div class="dmc-actions"><button type="button" class="dmc-cancel" data-dmc-cancel>Huỷ</button><button type="button" class="dmu-add" data-dmc-add disabled>Thêm thiệp vào giỏ</button></div>' : '') +
      '</div>';
  }
  function bindMsg(box, onChange) {
    var ta = box.querySelector('[data-dmc-input]'), pv = box.querySelector('[data-dmc-preview]'),
      ln = box.querySelector('[data-dmc-lines]'), ct = box.querySelector('[data-dmc-count]'), last = '';
    function upd() {
      var lines = wrapMsg(ta.value);
      if (lines.length > MSG.lines) { var pos = ta.selectionStart; ta.value = last; try { ta.setSelectionRange(pos - 1, pos - 1); } catch (e) {} lines = wrapMsg(ta.value); ln.className = 'bad'; ln.textContent = 'Tối đa ' + MSG.lines + ' dòng – bạn rút gọn lời chúc nhé'; }
      else { ln.className = ''; ln.textContent = lines.length + '/' + MSG.lines + ' dòng · tối đa ' + MSG.per + ' ký tự/dòng'; }
      last = ta.value;
      ct.textContent = ta.value.length + '/' + MSG.max;
      pv.textContent = lines.join('\n');
      onChange && onChange(lines.join('\n'));
    }
    ta.addEventListener('input', upd); upd();
    return { value: function () { return wrapMsg(ta.value).join('\n'); }, focus: function () { ta.focus(); } };
  }
  function mountCardPDP() {
    if (location.pathname.indexOf('/products/' + CARD) < 0) return;
    var form = document.querySelector('form[id^="product-form-"][action*="/cart/add"]') || document.querySelector('product-form form');
    if (!form || form.querySelector('.dmc-msg')) return;
    var host = document.createElement('div'); host.className = 'dmc-pdp'; host.innerHTML = qtyNote('0 0 .8rem') + msgHTML(false);
    var hid = document.createElement('input'); hid.type = 'hidden'; hid.name = 'properties[' + MSG.prop + ']';
    var btns = form.querySelector('.product-form__buttons') || form.lastElementChild;
    form.insertBefore(host, btns); form.appendChild(hid);
    var m = bindMsg(host, function (v) { hid.value = v; });
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (!m.value()) { e.preventDefault(); e.stopImmediatePropagation(); var l = host.querySelector('[data-dmc-lines]'); l.className = 'bad'; l.textContent = 'Bạn nhập lời chúc cho thiệp nhé'; m.focus(); }
    }, true);
  }

  /* ---------- 2) Upsell gói quà ---------- */
  var giftCache = null;
  function loadGifts() {
    if (giftCache) return giftCache;
    giftCache = Promise.all(GIFT.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (a) { return a.filter(Boolean); });
    return giftCache;
  }
  function itemHTML(p, row) {
    var fv = FORM[p.handle] ? formVariant(p, formOf(lastCart)) : null;
    var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
    var av = p.variants.filter(function (v) { return v.available; });
    var opts = fv ? '<span class="dmu-price">' + money(fv.price) + '</span>' : av.length > 1 ? '<select class="dmu-sel" aria-label="Chọn loại">' + av.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title.replace('Dáng ', '')) + ' · ' + money(v.price) + '</option>'; }).join('') + '</select>' : '<span class="dmu-price">' + money(p.variants[0].price) + '</span>';
    var short = esc(p.title.split(' – ')[0].replace(/ Dear eM$/, '').replace(/ Signature$/, ''));
    var pic = img ? '<img src="' + img + '" alt="" width="48" height="48" loading="lazy">' : '<span class="dmu-ph"></span>';
    var btn = '<button type="button" class="dmu-add">' + (p.handle === CARD ? '+ Viết lời chúc' : '+ Thêm') + '</button>';
    var head = '<div class="dmu-item" data-h="' + p.handle + '" data-vid="' + (fv || av[0] || p.variants[0]).id + '">';
    if (row) return head + '<div class="dmu-top">' + pic + '<a href="/products/' + p.handle + '" class="dmu-name">' + short + '</a></div>' + opts + btn + '</div>';
    return head + pic + '<div class="dmu-info"><a href="/products/' + p.handle + '" class="dmu-name">' + short + '</a>' + opts + '</div>' + btn + '</div>';
  }
  function minPrice(items) { var m = Infinity; items.forEach(function (p) { p.variants.forEach(function (v) { if (v.price < m) m = v.price; }); }); return m === Infinity ? '' : money(m); }
  function boxHTML(items, title, mode) {
    if (mode === 'drawer') {
      return '<details class="dmu dmu--drawer"><summary class="dmu-sum"><span aria-hidden="true">🎁</span><b>' + title + '</b><span>Hộp · Túi · Thiệp, từ ' + minPrice(items) + '</span><i aria-hidden="true">▾</i></summary>' +
        '<div class="dmu-body">' + qtyNote() + '<div class="dmu-row">' + items.map(function (p) { return itemHTML(p, true); }).join('') + '</div></div></details>';
    }
    if (mode === 'page') return '<div class="dmu"><p class="dmu-h">' + title + '</p>' + qtyNote() + '<div class="dmu-row">' + items.map(function (p) { return itemHTML(p, true); }).join('') + '</div></div>';
    return '<div class="dmu"><p class="dmu-h">' + title + '</p>' + qtyNote() + '<div class="dmu-list">' + items.map(function (p) { return itemHTML(p, false); }).join('') + '</div></div>';
  }
  function inCartIds() { return getCart().then(function (c) { return c.items.map(function (i) { return i.handle || i.product_handle; }); }); }
  /* đổi SKU hộp/túi trong giỏ cho đúng form */
  var routing = false;
  function routeCart() {
    if (routing) return Promise.resolve();
    return Promise.all([getCart(), loadGifts()]).then(function (a) {
      var cart = a[0], gifts = a[1], form = formOf(cart), jobs = [];
      cart.items.forEach(function (i) {
        var p = gifts.filter(function (g) { return g.handle === i.handle; })[0]; if (!p || !FORM[p.handle]) return;
        var want = formVariant(p, form); if (!want || want.id === i.variant_id) return;
        jobs.push({ key: i.key, qty: i.quantity, props: i.properties || {}, to: want.id });
      });
      if (!jobs.length) return;
      routing = true;
      var chain = Promise.resolve(), last = null, drawer = document.querySelector('cart-drawer');
      jobs.forEach(function (j) {
        chain = chain.then(function () { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: j.key, quantity: 0 }) }); })
          .then(function () {
            var b = { items: [{ id: j.to, quantity: j.qty, properties: j.props }] };
            if (drawer) { b.sections = 'cart-drawer,cart-icon-bubble'; b.sections_url = location.pathname; }
            return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) }).then(function (r) { return r.json(); }).then(function (res) { last = res; });
          });
      });
      return chain.then(function () {
        if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        if (drawer && last && last.sections) { var it = (last.items && last.items[0]) || {}; it.sections = last.sections; try { drawer.renderContents(it); } catch (e) {} }
      }).finally(function () { setTimeout(function () { routing = false; }, 800); });
    });
  }
  /* trang hộp/túi: ẩn ô chọn form, ghi chú shop tự chọn */
  function mountFormPDP() {
    var h = Object.keys(FORM).filter(function (k) { return location.pathname.indexOf('/products/' + k) > -1; })[0]; if (!h) return;
    $$('variant-selects, .product-form__input--dropdown, .product-form__input--pill').forEach(function (el) { el.style.display = 'none'; });
    var vs = document.querySelector('variant-selects');
    if (vs && !document.querySelector('.dm-form-note')) vs.insertAdjacentHTML('afterend', '<p class="dm-form-note" style="margin:.8rem 0 1.2rem;font-size:1.35rem;color:#5d5866;background:#faf7ff;border:1px solid #e6dcf7;border-radius:12px;padding:1rem 1.2rem">Dear eM tự chọn form ' + (h.indexOf('hop') === 0 ? 'hộp' : 'túi') + ' (vuông hoặc chữ nhật) vừa với sản phẩm bạn mua: Vanity Case dùng form vuông, các sản phẩm khác dùng form chữ nhật.<br><br>ⓘ ' + QTY_NOTE + '</p>');
    Promise.all([getCart(), loadProduct()]).then(function (a) {
      var p = a[1]; if (!p) return; var v = formVariant(p, formOf(a[0])); if (!v) return;
      var inp = document.querySelector('form[id^="product-form-"] input[name="id"]'); if (inp && inp.value != v.id) { inp.value = v.id; }
      var sel = vs && vs.querySelector('select'); if (sel && sel.value !== v.options[0]) { sel.value = v.options[0]; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }
  function addToCart(vid, btn, props) {
    btn.disabled = true; var label = btn.textContent; btn.textContent = 'Đang thêm…';
    var drawer = document.querySelector('cart-drawer');
    var it = { id: +vid, quantity: 1 }; if (props) it.properties = props;
    var body = { items: [it] };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { btn.textContent = 'Hết hàng'; return; }
        btn.textContent = 'Đã thêm ✓';
        if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        if (drawer && res.sections) {
          var item = (res.items && res.items[0]) || {}; item.sections = res.sections;
          try { drawer.renderContents(item); drawer.classList.remove('is-empty'); } catch (e) {}
          setTimeout(mountCart, 300);
        } else {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { $$('.cart-count-bubble span[aria-hidden]').forEach(function (s) { s.textContent = c.item_count; }); });
        }
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  }
  function openCardEditor(item, btn) {
    var box = item.closest('.dmu'); var ex = box.querySelector('.dmc-msg');
    if (ex) { ex.remove(); return; }
    var wrap = document.createElement('div'); wrap.innerHTML = msgHTML(true); var ed = wrap.firstChild;
    var body = item.closest('.dmu-row, .dmu-list'); body.parentNode.insertBefore(ed, body.nextSibling);
    var add = ed.querySelector('[data-dmc-add]');
    var m = bindMsg(ed, function (v) { add.disabled = !v; });
    ed.querySelector('[data-dmc-cancel]').addEventListener('click', function () { ed.remove(); });
    add.addEventListener('click', function () { var v = m.value(); if (!v) return; var p = {}; p[MSG.prop] = v; addToCart(item.dataset.vid, add, p); });
    setTimeout(function () { m.focus(); }, 50);
  }
  document.addEventListener('change', function (e) { if (e.target.classList && e.target.classList.contains('dmu-sel')) { e.target.closest('.dmu-item').dataset.vid = e.target.value; } });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.dmu-add'); if (!b || b.hasAttribute('data-dmc-add')) return;
    e.preventDefault(); var it = b.closest('.dmu-item'); if (!it) return;
    if (it.dataset.h === CARD) { openCardEditor(it, b); return; }
    addToCart(it.dataset.vid, b);
  });

  function mountPDP() {
    var slot = document.querySelector('[data-dm-gift-upsell]'); if (!slot || slot.dataset.ready) return; slot.dataset.ready = 1;
    Promise.all([loadGifts(), getCart()]).then(function (a) {
      var gs = a[0]; if (!gs.length) return;
      /* đang xem Vanity Case thì gợi ý hộp/túi form vuông */
      if (/vanity/i.test(location.pathname)) lastCart = { items: (lastCart.items || []).concat([{ handle: 'vanity' }]) };
      slot.innerHTML = boxHTML(gs, 'Thêm gói quà để tặng ngay 🎁', 'pdp');
    });
  }
  function noteHTML() {
    return '<div class="dm-addr-note" role="note"><b>Lưu ý địa chỉ giao hàng:</b> ở bước thanh toán, vui lòng nhập <b>địa chỉ cũ (trước khi sáp nhập tỉnh/thành)</b>, gồm đủ phường/xã, quận/huyện, tỉnh/thành cũ. Nếu nhập theo địa chỉ mới, Dear eM không chịu trách nhiệm khi hàng bị thất lạc hoặc giao trễ.</div>';
  }
  function hideInCart(box, handles) {
    var any = false;
    $$('.dmu-item', box).forEach(function (it) { var inC = handles.indexOf(it.dataset.h) > -1; it.style.display = inC ? 'none' : ''; if (!inC) any = true; });
    var d = box.querySelector('.dmu'); if (d) d.style.display = any ? '' : 'none';
  }
  function mountCart() {
    if (!routing) routeCart();
    // giỏ hàng nổi: khối gói quà thu gọn 1 dòng, bấm để mở
    var footer = document.querySelector('cart-drawer .drawer__footer');
    if (footer && !footer.querySelector('.dm-addr-note')) {
      var ctas = footer.querySelector('.cart__ctas') || footer.lastElementChild;
      ctas && ctas.insertAdjacentHTML('beforebegin', noteHTML());
    }
    if (footer) {
      Promise.all([loadGifts(), inCartIds()]).then(function (a) {
        var h = document.querySelector('cart-drawer .drawer__footer'); if (!h) return;
        if (!h.querySelector('.dmu') && a[0].length) h.insertAdjacentHTML('afterbegin', boxHTML(a[0], 'Thêm gói quà', 'drawer'));
        hideInCart(h, a[1]);
      });
    }
    // trang giỏ hàng
    var page = document.querySelector('#main-cart-footer .cart__blocks, .cart__footer .cart__blocks');
    if (page && !page.querySelector('.dm-addr-note')) {
      var c2 = page.querySelector('.cart__ctas'); c2 && c2.insertAdjacentHTML('beforebegin', noteHTML());
    }
    var pitems = document.querySelector('#main-cart-items');
    if (pitems && !document.querySelector('.dmu--page')) {
      Promise.all([loadGifts(), inCartIds()]).then(function (a) {
        var gs = a[0].filter(function (p) { return a[1].indexOf(p.handle) < 0; });
        if (!gs.length || document.querySelector('.dmu--page')) return;
        pitems.insertAdjacentHTML('afterend', '<div class="page-width dmu--page">' + boxHTML(gs, 'Thêm gói quà cho đơn hàng 🎁', 'page') + '</div>');
      });
    }
  }
  function initCart() {
    mountCart();
    var obs = new MutationObserver(function (ms) {
      if (ms.every(function (m) { return m.target.closest && m.target.closest('.dmu'); })) return;
      clearTimeout(obs.t); obs.t = setTimeout(mountCart, 150);
    });
    var d = document.querySelector('cart-drawer'); d && obs.observe(d, { childList: true, subtree: true });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('#cart-icon-bubble,[name="add"]')) setTimeout(mountCart, 900); }, true);
  }

  function init() { initDeps(); mountPDP(); mountCardPDP(); mountFormPDP(); initCart(); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
